export const USER_ROUTES = {
    Login: {
        Name: "Login",
        Path: "/Login",
    },
    Home: {
        Name: "Home",
        Path: "/",
    },
    DashBoard: {
        Name: "DashBoard",
        Path: "/DashBoard",
    },
    Product: {
        Name: "Product",
        Path: "/Product",
    },
    PersonalProduct: {
        Name: "PersonalProduct",
        Path: "/PersonalProduct",
    },
    Organization: {
        Name: "Organization",
        Path: "/Organization",
    },
    Personal: {
        Name: "Personal",
        Path: "/Personal",
    },
    OrgOrderQuotation: {
        Name: "OrgOrderQuotation",
        Path: "/OrgOrderQuotation",
    },
    OrgOrder: {
        Name: "OrgOrder",
        Path: "/OrgOrder",
    },
    OrgOrderRegister: {
        Name: "OrgOrderRegister",
        Path: "/OrgOrder/register/:SK",
    },
    OrgOrderEdit: {
        Name: "/OrgOrderEdit",
        Path: "/OrgOrder/edit/:SK",
    },
    OrgDiagnosis: {
        Name: "OrgDiagnosis",
        Path: "/OrgDiagnosis",
    },
    OrgPayment: {
        Name: "OrgPayment",
        Path: "/OrgPayment",
    },
    PersonalOrder: {
        Name: "PersonalOrder",
        Path: "/PersonalOrder",
    },
    PersonalDiagnosis: {
        Name: "PersonalDiagnosis",
        Path: "/PersonalDiagnosis",
    },
    PersonalPayment: {
        Name: "PersonalPayment",
        Path: "/PersonalPayment",
    },
    Notice: {
        Name: "Notice",
        Path: "/Notice",
    },
    Qna: {
        Name: "Qna",
        Path: "/Qna",
    },
    Press: {
        Name: "Press",
        Path: "/Press",
    },
    Sales: {
        Name: "Sales",
        Path: "/Sales",
    },
    Myreg: {
        Name: "Myreg",
        Path: "/Myreg",
    },
    OrgMyreg: {
        Name: "OrgMyreg",
        Path: "/OrgMyreg",
    },
    Statistics: {
        Name: "Statistics",
        Path: "/Statistics",
    },
};
